<script setup lang="ts">
  import { FlowTravelDatesWidget } from '@/widgets/Flow'
  import { useApiRequestsAbort } from '@/shared/composables'

  useApiRequestsAbort()
</script>

<template>
  <FlowTravelDatesWidget />
</template>
